var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-tabs nav-fill ma-1 mt-3 mb-3"},_vm._l((_vm.list),function(item,idx){return _c('li',{staticClass:"nav-item"},[_c('a',{class:_vm.val==idx?'nav-link active':'nav-link ',on:{"click":function($event){return _vm.clk_item(idx)}}},[_c('span',{class:_vm.val==idx?'sborder':'',domProps:{"innerHTML":_vm._s(item)}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }